import { Grid, Stack } from "@mui/material";
import { UserContext } from "components/context/UserProvider";
import Layout from "components/ui/molecules/Layout";
import { TopRightMenu } from "components/ui/molecules/TopRightMenu";
import EventWidget from "models/actions/EventWidget";
import DealWidget from "models/deals/DealWidget";
import HistoryWidget from "models/history/HistoryWidget";
import SourcingWidget from "models/sourcings/SourcingWidget";
import { useContext } from "react";
import { GlobalSearchBox } from "./components/ui/atoms/SearchDrawerButton";

const Home = ({}) => {
  const { user } = useContext(UserContext);

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          width={1}
        >
          <GlobalSearchBox delay={0} />
          <TopRightMenu style={{ marginLeft: "auto" }}></TopRightMenu>
        </Stack>
      </Layout>
      <Layout content>
        <Grid container spacing={1}>
          <Grid size={{ md: 6, xs: 12 }}>
            <HistoryWidget userId={user.id} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <SourcingWidget userId={user.id} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <EventWidget userId={user.id} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <DealWidget userId={user.id} />
          </Grid>
        </Grid>
      </Layout>
    </Layout>
  );
};

export default Home;
